import React, { useContext } from "react";
import { data } from "./Index";
import Forcasttime from "./Forcasttime";
import Forcastday from "./Forcastdate";
import Map from "./Map";
const Mappage = () => {
	const boxdata1 = useContext(data);
	const { weatherData } = boxdata1;

	return (
		<>
			<div className="middlecontentmap">
				<Map
					coordinates={boxdata1.coordinates}
					mapStyles={boxdata1.mapStyles}
					icons={weatherData.icon}
					cityname={weatherData.cityName}
					weather={weatherData.temprature}
				/>
			</div>
			{
				<div className="rightcontent">
					<div className="forcasttime">
						<h3>TODAY'S FORCAST</h3>
						{boxdata1.forcasttimedata.map((data, index) => (
							<Forcasttime
								key={index}
								date={data.date}
								weather={data.weather}
								icon={data.icon}
								max={data.max}
								min={data.min}
							/>
						))}
					</div>
					<div className="forcastday">
						<h3>5-DAY FORCAST</h3>
						{boxdata1.forcastdaydata.map((data, index) => (
							<Forcastday
								key={index}
								date={data.date}
								days={data.days}
								weather={data.weather}
								icon={data.icon}
								max={data.max}
								min={data.min}
							/>
						))}
					</div>
				</div>
			}
		</>
	);
};

export default Mappage;
